import { LOGIN, LOGIN_FAILURE, LOGIN_SUCCESS } from "./LoginAction";
import { LOCATION_CHANGE } from "react-router-redux";

const defaultState = {
  userInfo: {},
  isLoading: false,
  isAuthenticated: true,
  token: null,
  role: null,
  error: null,
  districtName: null,
};
const LoginReducer = (state = defaultState, action) => {
  switch (action.type) {
    case LOGIN:
      return { ...state, isLoading: true };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        userInfo: action.payload,
        token: action.payload.token,
        role: action.payload.role,
        districtName: action.payload.districtName,
        isAuthenticated: true,
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        isLoading: false,
        isAuthenticated: false,
        error: action.payload,
      };
    case LOCATION_CHANGE:
      return state;
    default:
      return state;
  }
};
export default LoginReducer;
